var map = {
	"./bancodofuturo/base-consultas/LogDetalhes.vue": "fd90",
	"./legado/base-consultas/LogDetalhes.vue": "360d"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "e6f1";
module.exports = webpackAsyncContext;